<!-- src/routes/+layout.svelte -->
<script lang="ts">
  import '../app.postcss';
  import { invalidate } from '$app/navigation';
  import { onMount } from 'svelte';
  import { dev } from '$app/environment';
  import { inject } from '@vercel/analytics';
  import { updateProfile } from '$lib/api/profile';
  import Toasts from '$lib/components/Toasts.svelte';

  inject({ mode: dev ? 'development' : 'production' });

  export let data;

  let { supabase, session, profile, isAdmin } = data;
  $: ({ supabase, session, profile, isAdmin } = data);

  onMount(() => {
    const { data } = supabase.auth.onAuthStateChange((event, _session) => {
      if (_session?.expires_at !== session?.expires_at) {
        invalidate('supabase:auth');
      } else if (session) {
        updateProfile();
      }
    });

    return () => data.subscription.unsubscribe();
  });
</script>

<svelte:head>
  <title>OttoIQ</title>

  {#if !import.meta.env.PROD}
    <script
      data-project-id="r7iAPz3rQ3CjGDIuxLmGt1DqoPXmYbUf1wlDz4PN"
      data-is-production-environment="false"
      src="https://snippet.meticulous.ai/v1/meticulous.js"
    ></script>
  {/if}
</svelte:head>

<div class="container">
  <slot />
</div>

<Toasts />

<style>
  .container {
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
  }
</style>
